import { render, staticRenderFns } from "./DialogDetailAnnounceList.vue?vue&type=template&id=5fc31dbb&"
import script from "./DialogDetailAnnounceList.vue?vue&type=script&lang=js&"
export * from "./DialogDetailAnnounceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports